import { useMutation } from 'react-query';
import { IGvdasaProps } from '../../types';
import {
  createGvdasaIntegrationAsync,
  deleteGvdasaIntegrationAsync,
  getAllGvdasaIntegrationsAsync,
  getGvdasaIntegrationByIdAsync,
  updateGvdasaIntegrationAsync,
} from '../../index';

export const useCreateGvdasaIntegrationAsync = () =>
  useMutation(createGvdasaIntegrationAsync);

export const useGetGvdasaIntegrationByIdAsync = () =>
  useMutation(getGvdasaIntegrationByIdAsync);

export const useGetAllGvdasaIntegrationsAsync = () =>
  useMutation(getAllGvdasaIntegrationsAsync);

export const useUpdateGvdasaIntegrationAsync = () =>
  useMutation(updateGvdasaIntegrationAsync);

export const useDeleteGvdasaIntegrationAsync = () =>
  useMutation(deleteGvdasaIntegrationAsync);
